import styled from 'styled-components';

import CalendarIcon from 'assets/CalendarIcon.svg';

import { StyledDatePicker as BaseStyledPicker } from 'components/FormField/styles';
import colors from 'styles/colors';

import 'react-datepicker/dist/react-datepicker.css';

export const LabelContainer = styled.div`
  display: flex;
  width: 100%;
`;

export const StyledDatePicker = styled.div`
  display: flex;
  height: 56px;
  flex-direction: column;
  align-items: flex-start;
  flex-grow: 1;

  && ${BaseStyledPicker} {
    width: 100%;

    input:read-only:disabled {
      background-color: ${colors.fleetOffGray};
    }

    input:focus {
      background: url(${CalendarIcon}) 2% 40% no-repeat;
    }
  }

  label {
    font-size: 12px;
    margin-bottom: 4px;
  }
`;
